var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKretosLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 275.8 318.4",
    style: {
      enableBackground: "new 0 0 275.8 318.4"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "135.7,159.2 237.4,57.5 275.8,79.6 275.8,159.2 275.8,238.8 237.4,261  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "137.9,0 206.8,39.8 208.6,40.8 112.9,136.5 90.1,159.2 90.1,228.4 58,228.4 58,90.1 90.1,90.1  90.1,159.2 112.9,182 208.6,277.6 206.8,278.6 137.9,318.4 69,278.6 0,238.8 0,159.2 0,79.6 69,39.8  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKretosLogo);
export default __webpack_public_path__ + "static/media/kretos_logo.7e3dc7819be822b3f794b322454de2b9.svg";
export { ForwardRef as ReactComponent };